import queryString from "query-string";
import { GET_LIST } from "../../api/department";

const state = {
  list: [],
  mode: "",
};

const mutations = {
  SET_LIST: (states, payload) => {
    states.list = payload;
  },
  SET_MODE: (states, payload) => {
    states.mode = payload;
  },
};

const actions = {
  GET_LIST: async ({ commit }, query) => {
    query = queryString.stringify(query);
    const resp = await GET_LIST(query);
    const data = resp.data.data;
    commit("SET_LIST", data);
  },
};

const getters = {
  list: (states) => states.list,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
